import { Form } from 'components/organisms';
import { channelVideoInitialValues } from 'components/organisms/forms/channel-video/ChannelVideoForm';
import { useCustomParamId, useParamId } from 'hooks/useParamId';
import { useNavigate } from 'react-router-dom';
import {
  useGetChannelVideo,
  useUpdateChannelVideoContracts,
} from 'services/channel';
import { IChannelVideoForm } from 'services/channel/types/query';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditChannelVideo = () => {
  const channelId = useParamId('channel');
  const videoId = useCustomParamId('videoId', 'channel');
  const navigate = useNavigate();

  const updateVideoContract = useUpdateChannelVideoContracts();

  const getChannelVideo = useGetChannelVideo(videoId);

  const onSubmit = async (values: IChannelVideoForm) => {
    await updateVideoContract.mutateAsync(
      {
        channelId: channelId,
        videoId: videoId,
        videoContracts:
          values.videoContracts.map(c => ({
            contractId: c.contractId,
            divisionPercentage: c.divisionPercentage,
            endDate: null,
            startDate: c.startDate,
          })) ?? [],
      },
      {
        onSuccess: () =>
          navigate(`/channel/${channelId}/channel-video/${videoId}/contracts`),
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };

  return (
    <Form.ChannelVideo
      status={{ isLoading: getChannelVideo.isLoading, displayMode: false }}
      i18nextPrefix='channel'
      initialValues={
        getChannelVideo.data
          ? { ...channelVideoInitialValues, ...getChannelVideo.data }
          : channelVideoInitialValues
      }
      onSubmit={onSubmit}
      tittle={getChannelVideo.data?.videoTitle ?? '-'}
    />
  );
};

export default EditChannelVideo;
